import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Flex, Box, Heading, Card, Image } from '@magicsoup.io/stock'
import { Square } from '../../styled'

const Hero = () => (
  <StaticQuery
    query={graphql`
      query HeroQuery {
        generalJson {
          hero {
            displayTitle
            subTitle
          }
        }
        hero:file(relativePath: { eq: "assets/hero.svg" }) {
          publicURL
        }
      }
    `}
    render={data => (
      <Card variant='grey'>
        <Flex
          p={5}
          alignItems='center'
          flexWrap="wrap"
        >
          <Square width={[1,1,1/2]} p={[3,5,5]}>
            <Image width="100%" maxWidth="500px" src={data.hero.publicURL} />
          </Square>
          <Flex width={[1,1,1/2]} flexDirection="column" p={[2,3,3]}>
            <Heading as="h1" variant="hero" fontSize={[3,6,6]} lineHeight={['32px', '60px']} m={[2]}>{data.generalJson.hero.displayTitle}</Heading>
            <Heading as="h2" variant="heroSubtitle" fontSize={[2,5,5]} lineHeight={['32px', '48px']} m={[2]}>{data.generalJson.hero.subTitle}</Heading>
          </Flex>
        </Flex>
      </Card>
    )}
  />
)

export default Hero
